// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"1dd5f33f","351":"1dd5f33f","766":"547b3b71"}[chunkId] + ".chunk.css";
};